import { postRequest } from '@/core';
import { subOrders } from '@/requests';

export default async function createParallelSubOrderRequest(id) {
	let url = subOrders.getCreateParallelPath(id);
	let response = await postRequest(url);
	return response;
}
